import { BASE_URL } from "@/constants/endpoints";
import { ECheqRequestDetail } from "@/pages/requests/echeq/schema/echeq-requests.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let ECheqRequestsApiPromise: Promise<AxiosInstance> | null = null;

const getECheqRequestsApi = async (): Promise<AxiosInstance | null> => {
  if (ECheqRequestsApiPromise) return ECheqRequestsApiPromise;
  ECheqRequestsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return ECheqRequestsApiPromise;
};

export interface GetECheqRequestsProps {
  FechaDesde?: string;
  FechaHasta?: string;
  Monto?: string;
  NroCuenta?: string;
  Titular?: string;
  ClaveSucursal?: string[];
  Estados?: number[];
  Solicitante?: string;
  "P.Pagina": number;
  "P.Records": number;
}

export const getECheqRequests = async (props: GetECheqRequestsProps) => {
  const api = await getECheqRequestsApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudECheq/GetListadoSolicitudesECheq?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetECheqRequestProps {
  Id: number;
}

export const getECheqRequest = async (
  props: GetECheqRequestProps,
): Promise<ECheqRequestDetail | null> => {
  const api = await getECheqRequestsApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudECheq/GetDetalleSolicitudECheq?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};
